import { useEffect, useState } from 'react';
import { CronoSearchBarWrapper } from './style';
import SearchIcon from 'crono-fe-common/icons/Icon-Search';
import { colors } from 'crono-fe-common/theme';
import { TextField } from '@mui/material';
import CloseMIcon from 'crono-fe-common/icons/Icon-Close';

interface IProps {
  initialSearch?: string;
  setDebouncedSearch: (query: string) => void;
  placeholder?: string;
  className?: string;
  id?: string;
  autoFocus?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
  size?: 'sm' | 'md';
  debounceDelay?: number;
}

/** @deprecated Use DebouncedSearchInput from `src/components` instead. */
export const CronoSearchBar = ({
  setDebouncedSearch,
  placeholder = 'Search...',
  initialSearch,
  className,
  id,
  autoFocus,
  inputRef,
  size = 'md',
  debounceDelay = 400,
}: IProps) => {
  const [search, setSearch] = useState<string>(initialSearch ?? '');

  useEffect(() => {
    setSearch(initialSearch ?? '');
  }, [initialSearch]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(search);
    }, debounceDelay);

    return () => clearTimeout(timeout);
  }, [search]);

  return (
    <CronoSearchBarWrapper className={className}>
      <SearchIcon className="search-icon" color={colors.grey11} />

      <TextField
        id={id}
        className="search-text-field"
        variant="standard"
        placeholder={placeholder}
        autoComplete="off"
        autoFocus={autoFocus}
        inputRef={inputRef}
        value={search}
        onChange={(ev) => setSearch(ev.target.value)}
        onKeyDown={(ev) => {
          if (ev.key === 'Enter') {
            ev.stopPropagation();
            ev.preventDefault();
            //for immediate rerendering
            setDebouncedSearch(search);
          }
        }}
        InputProps={{
          disableUnderline: true,
          endAdornment:
            search === '' ? null : (
              <CloseMIcon
                size={size === 'sm' ? 16 : 20}
                className="remove-text-icon"
                color={colors.grey11}
                onClick={() => {
                  setSearch('');
                  //For immediate rerendering
                  setDebouncedSearch('');
                }}
              />
            ),
        }}
        sx={{
          width: '100%',
          input: {
            fontWeight: '400',
            padding: '4px 0px',
            fontSize: size === 'sm' ? '12px' : '14px',
            '&::placeholder': {
              opacity: 1,
              color: colors.grey11,
            },
          },
        }}
      />
    </CronoSearchBarWrapper>
  );
};
